import HCLTreeMxGraph from '../HCLTreeMxGraph/HCLTreeMxGraph';

/**
 * Base class that specifies methods for encoding concrete implementations of {@link HCLTreeMxGraph}
 * such as {@link FaultTreeMxGraph}, {@link EventTreeMxGraph}, {@link BayesianNetworkMxGraph} into JSON.
 */
abstract class HCLTreeMxGraphEncoder {
  private graph: HCLTreeMxGraph;

  /**
   * @param {HCLTreeMxGraph} graph
   */
  protected constructor(graph: HCLTreeMxGraph) {
    this.graph = graph;
  }

  /**
   * @return {HCLTreeMxGraph}
   */
  getGraph(): HCLTreeMxGraph {
    return this.graph;
  }

  /**
   * @return {[index: string]: any} - JSON that describes {@link HCLTreeMxGraphEncoder#graph}
   */
  abstract encode(): {[index: string]: any};
}

export default HCLTreeMxGraphEncoder;
